import React, { useContext, useState } from 'react';
import { CloseRounded } from '@mui/icons-material';
import { Button, CircularProgress } from '@mui/material';
import ModalContext from '../../../context/ModalContext.js';
import AuthContext from '../../../context/AuthContext.js';
import { useNavigate } from 'react-router-dom';

const CouponStatusModal = ({ modalDetails }) => {
	const modalCtx = useContext(ModalContext);
	const authCtx = useContext(AuthContext);
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);
	const [clicked, setClicked] = useState(null);

	const handleStatus = async (status) => {
		setClicked(status);
		setLoading(true);
		try {
			const response = await fetch(`${process.env.REACT_APP_API_URI}/v3/admin/coupon/step/${modalDetails.couponId}/confirm`, {
				method: 'PATCH',
				headers: { 
					'Content-Type': 'application/json', 
					Authorization: "Bearer " + authCtx.token 
				},
				body: JSON.stringify({ status })
			});
			const data = await response.json();
			if (data.status === 'success') {
				modalCtx.closeModal();
				modalCtx.setPageUpdate({ 
					page: "Coupons", 
					couponId: modalDetails.couponId,
					status
				});
				navigate('/coupons');
			}
		} catch (error) {
			console.error('Error updating coupon status:', error);
		} finally {
			setLoading(false);
			setClicked(null);
		}
	}

	return (
		<div className="modal-container">
			<div className='modal-header' style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
				<h1>Confirm Coupon Status</h1>
				<CloseRounded onClick={() => modalCtx.closeModal()}className="modal-close-icon"/>
			</div>
			<div className="modal-body">
				<span>How would you like to proceed with this coupon?</span>
			</div>
			<div className="modal-footer" style={{ display: 'flex', justifyContent: 'flex-end', gap: 16 }}>
				<Button
					onClick={() => handleStatus('approved')}
					disabled={loading}
					variant="contained"
					color="primary"
					style={{ minWidth: 160 }}
				>
					{loading && clicked === 'live' ? <CircularProgress size={16} style={{ color: '#fff', marginRight: 8 }} /> : null}
					Make it Live
				</Button>
				<Button
					onClick={() => handleStatus('pending')}
					disabled={loading}
					variant="outlined"
					color="primary"
					style={{ minWidth: 160 }}
				>
					{loading && clicked === 'pending' ? <CircularProgress size={16} style={{ color: '#1976d2', marginRight: 8 }} /> : null}
					Keep it Pending
				</Button>
			</div>
		</div>
	);
}

export default CouponStatusModal; 